import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Api} from '../utils';
import {of} from "rxjs/observable/of";
import {User} from "@models/user.interface";
import {catchError} from "rxjs/operators/catchError";
import {CookieService} from "ngx-cookie";
import {Router} from "@angular/router";
import {Store} from '@ngrx/store';
import {
  ClearOrderCompletionState,
  ClearOrderCreationState,
  ClearShipmentsState, LoadUser, RemoveProfile,
} from '@store/actions';
import {RequestsHandler} from '@services/requests.service';
import {selectUser} from "@store/reducers";
import 'rxjs/add/operator/map';

@Injectable()
export class AuthService {
  token: string;
  user: User;
  constructor(
    private http: HttpClient,
    private api: Api,
    private handler: RequestsHandler,
    private _cookieService: CookieService,
    private router: Router,
    private store: Store<any>
  ) {
    this.store.select(selectUser)
      .subscribe((data: any) => {
        this.user = data;
    });
  }

  register(data) {
    return this.http
      .post(this.api.getUrl('auth/register'), data, {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(err);
      });
  }

  resetPassword(data) {
    return this.http
      .post(this.api.getUrl('auth/password/email'), data, {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(err);
      });
  }

  updatePassword(data) {
    return this.http
      .patch(this.api.getUrl('auth/password/reset'), data, {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(err);
      });
  }

  login(email: string, password: string): Observable<User> {
    return this.http.post(
      this.api.getUrl('auth/login'),
      JSON.stringify({email, password}),
      {headers: this.handler.headers()}
      )
      .map((response: User) => {
        const token: string = response && response.token;
        const role: number = response && response.role;
        if (token && (role == 2 || role == 5)) {
          this.token = token;
          this._cookieService.put('auth_token', token);
          this.router.navigate([`${role === 2 ? 'dashboard' : 'admin/dashboard'}`]);
          return response;
        } else {
          return null;
        }
      });
  }

  logout(): void {
    this.token = null;
    this._cookieService.remove('auth_token');
    this.store.dispatch(new RemoveProfile());
    sessionStorage.removeItem('account');
    sessionStorage.removeItem('admin');
    this.store.dispatch(new ClearShipmentsState());
    this.store.dispatch(new ClearOrderCreationState());
    this.store.dispatch(new ClearOrderCompletionState());
    this.router.navigate(['login']);
  }

  getProfile() {
    return this.http
      .get(this.api.getUrl('account/profile'), {headers: this.handler.headers()})
      .map((response: User) => {
        if (response) {
          this.store.dispatch(new LoadUser({user: response}));
          return response;
        } else {
          this.store.dispatch(new RemoveProfile());
          return null;
        }
      })
      .catch((err: any) => {
        switch (err.status) {
          case 401: this.logout(); break;
          case 403: this.logout(); break;
          case 404: this.logout();  break;
          default : this.handler.handleError(err);
        }
        return Observable.throw(new Error(err));
      });
  }

  getUser() {
    return this.http.get(this.api.getUrl('account/profile'), {headers: this.handler.headers()})
      .map((response: User) => {
        if (response) {
          this.store.dispatch(new LoadUser({user: response}));
          return response;
        } else {
          this.store.dispatch(new RemoveProfile());
          return null;
        }
      })
      .pipe(catchError(() => of(null)));
  }

  hasRole = () => this.user && this.user.role;

  isAdmin() {
    return this.hasRole() === 5;
  }

  isMaster() {
    return this.hasRole() === 1;
  }

  isUser() {
    return this.hasRole() === 2;
  }
}




// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts